export { default } from '../pattern/SinglePatternView';



// WEBPACK FOOTER //
// ./src/components/async/SinglePatternView.js